import React from 'react';
import './ConfirmModal.css';

/**
 * Accessible confirm dialog (replaces window.confirm).
 */
const ConfirmModal = ({
  isOpen,
  title = 'Confirm',
  message,
  /** Optional controls (e.g. cascade checkboxes) rendered below the message */
  children,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  danger = false,
  loading = false,
  loadingLabel = 'Please wait…',
  /** 'light' (default): shell vars. 'dark': panels on dark fitness backgrounds. */
  variant = 'light',
}) => {
  if (!isOpen) return null;

  const overlayClass =
    variant === 'dark'
      ? 'confirm-modal-overlay on-dark-surface'
      : 'confirm-modal-overlay';

  return (
    <div
      className={overlayClass}
      role="presentation"
      onClick={loading ? undefined : onCancel}
    >
      <div
        className="confirm-modal-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-modal-title"
        aria-describedby="confirm-modal-desc"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="confirm-modal-title" className="confirm-modal-title">{title}</h2>
        {message != null && message !== '' && (
          <p id="confirm-modal-desc" className="confirm-modal-message">{message}</p>
        )}
        {children && (
          <div className="confirm-modal-extra" aria-describedby={message ? undefined : 'confirm-modal-title'}>
            {children}
          </div>
        )}
        <div className="confirm-modal-actions">
          <button
            type="button"
            className="confirm-modal-btn confirm-modal-btn-cancel"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`confirm-modal-btn ${danger ? 'confirm-modal-btn-danger' : 'confirm-modal-btn-primary'}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? loadingLabel : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
